import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PesquisaPropostaDto } from '../model/dto/PesquisaPropostaDto';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProgramaPacDto } from '../model/dto/ProgramaPacDto';
import { AgenteFinanceiro } from '../model/AgenteFinanceiro';

@Injectable({
  providedIn: 'root'
})
export class PesquisaPropostaService {

  private BASE_URL = './rest/proposta-pac';

  constructor(private http: HttpClient) {}

  obterProposta(filtros: PesquisaPropostaDto): Observable<PesquisaPropostaDto[]> {
    return this.http.post<PesquisaPropostaDto[]>(`${this.BASE_URL}`, filtros, blockUi()).pipe();
  }

  obterProgramasPac(): Observable<ProgramaPacDto[]> {
    return this.http.get<ProgramaPacDto[]>(`${this.BASE_URL}/programas`, blockUi()).pipe();
  }

  buscaAgentesFinaceirosFiltro(filtro : string): Observable<AgenteFinanceiro[]> {
    return this.http.post<AgenteFinanceiro[]>(`${this.BASE_URL}/agentes-financeiros-filtro`, filtro, blockUi()).pipe();
  }

  buscaAgentesFinaceiros(): Observable<AgenteFinanceiro[]> {
    return this.http.get<AgenteFinanceiro[]>(`${this.BASE_URL}/agentes-financeiros`, blockUi()).pipe();
  }
}